module.exports = __webpack_public_path__ + "static/media/icon-money_ball-selected.76484341.svg";